export default __webpack_public_path__ + "static/media/complementary--snow--g4.767b8bcc.png";